import { NavbarItemIcon } from "./NavbarItemIcon";
import { NavbarItemProps } from "./NavbarItem";
import clsx from "clsx";

export const NavbarItemDesktop = ({
  active,
  children,
  leadIcon,
  leadIconProps = {},
  tailIcon,
  anchorActive,
  ...rest
}: NavbarItemProps) => {
  return (
    <button
      className={clsx(
        "relative group my-2 px-2 gap-x-2 py-1! items-center hidden md:flex cursor-pointer rounded-lg",
        {
          "text-blue-grey-950 hover:bg-neutral-100": !active,
          "text-text-accent-blue bg-background-button-secondary": active,
          "bg-blue-grey-300": anchorActive,
        },
        rest.className
      )}
      aria-current={active}
      {...rest}
    >
      {leadIcon && <NavbarItemIcon icon={leadIcon} {...leadIconProps} />}
      {children && <span className="hidden md:block">{children}</span>}
      {tailIcon && <NavbarItemIcon icon={tailIcon} />}
    </button>
  );
};
